import './deep-merge-c6cfd18c.js';
import './shadows.js';
import './create-theme-grid.js';
import '@vebox/etui-colors';
import './create-theme-palette.js';
import './create-theme-spacing.js';
import './create-theme-typography.js';
import './create-theme-breakpoints.js';
import { createTheme } from './create-theme.js';

const defaultTheme = createTheme();

export { defaultTheme };
